import { MutationHookOptions, useMutation } from '@apollo/client/react';
import { GetNotificationPreferencesAndLevelQuery } from '../../../../../../__generated__/loma';
import {
  getNotificationPreferencesAndLevelQuery,
  unsubscribeNotificationPreferencesMutation,
} from '../graphql';
import { useGlobalSettings } from '../../../../hooks/useGlobalSettings';
import { usePageContext } from '../../../../hooks/PageContext/usePageContext';
import { Channels, PreferenceLevels } from '../types';

interface NotificationPreferencesMutateOptions {
  data?: GetNotificationPreferencesAndLevelQuery;
  options?: MutationHookOptions;
}

export const useUnsubscribeNotificationPreferenceMutate = ({
  data: notificationPreferencesAndLevelData,
  options,
}: NotificationPreferencesMutateOptions) => {
  const { state: pageContext } = usePageContext();

  const { hipaaCompliant } = useGlobalSettings();

  const {
    experienceHost,
    embedReferrerUrl,
    requestUrl,
    trackingNumbers,
    orderNumbers,
  } = pageContext;

  const referrerUrl =
    experienceHost === 'EMBED' && embedReferrerUrl
      ? embedReferrerUrl
      : (requestUrl ?? window?.location.href);

  const trackingNumber = (trackingNumbers && trackingNumbers[0]) ?? '';
  // in the context of messaging API, orderNumber is called orderId
  const orderId = (orderNumbers && orderNumbers[0]) ?? '';

  const notificationPreferences =
    notificationPreferencesAndLevelData?.getNotificationPreferencesAndLevel ??
    undefined;

  const {
    preferenceLevel,
    modifiedDatetime = '',
    isActive,
    isGuest,
  } = notificationPreferences ?? {};

  const [mutate, { loading }] = useMutation(
    unsubscribeNotificationPreferencesMutation,
    {
      refetchQueries: [getNotificationPreferencesAndLevelQuery],
      awaitRefetchQueries: true,
      ...options,
    },
  );

  const onUnsubscribeMutate = (currentChannel: Channels) => {
    mutate({
      variables: {
        ...pageContext,
        preferenceLevel: preferenceLevel || PreferenceLevels.TRACKING,
        retailerMoniker: pageContext.retailerMoniker,
        trackingNumber,
        orderId,
        channel: currentChannel,
        modifiedDatetime,
        isActive,
        isGuest,
        referrerUrl,
        hipaaCompliant,
      },
    }).catch((error) => console.log(error));
  };

  return {
    onUnsubscribeMutate,
    loading,
  };
};
